<template>
  <div class="container">
    <div class="carousel carousel--social-media">
      <div class="carousel__content-wrapper" :class="{ row: !onMobile }">
        <div class="carousel__content-text">
          <h2 class="carousel__content-title">{{ t.socialsTitle }}</h2>
          <div class="carousel__content-description">
            {{ t.socialsDescription }}
          </div>
        </div>

        <!-- Slider navigation - reuse classes from general sliders. -->
        <div class="carousel__navigation" ref="navigation">
          <div class="navigation-button navigation-button--prev"></div>
          <div class="navigation-button navigation-button--next"></div>
        </div>
      </div>

      <div class="carousel__slides">
        <div class="carousel__slider" ref="swiper">
          <div class="swiper-wrapper">
            <div
              v-for="slide in slides"
              :key="slide.id"
              class="carousel__slide swiper-slide">
              <a
                class="carousel__slide-image"
                v-if="slide.post_image"
                :href="slide.post_url"
                target="_blank">
                <img
                  :src="slide.post_image"
                  class="responsive-image__img"
                  :alt="`${slide.network_type} post image`"
                  loading="lazy" />
              </a>
              <div class="carousel__slide-content">
                <div class="carousel__slide-content-meta">
                  <div
                    :class="`social-media__icon social-media__icon--${slide.network_type}`"></div>
                  <a
                    :href="slide.user_url"
                    :class="`social-media__channel-link social-media__channel-link--${slide.network_type}`"
                    target="_blank">
                    {{ slide.user_full_name }}
                  </a>
                  <div class="social-media__post-date" v-if="slide.post_date">
                    {{ timeAgo(slide.post_date) }}
                  </div>
                </div>
                <div class="carousel__slide-text" v-if="slide.post_text">
                  <a
                    :href="slide.post_link"
                    class="carousel__slide-link"
                    target="_blank">
                    {{ slide.post_text }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 3rd
import Swiper, { Navigation } from 'swiper';
import moment from 'moment';
// utils
import translationStrings from '../translations/translationStrings';
import { getSocialMediaPosts } from '../utils/api';
import { isMobile } from '../utils/isMobile';

export default {
  name: 'social-media-slider',
  props: {
    lang: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      swiper: null,
      slides: [],
      onMobile: isMobile(),
      t: translationStrings,
    };
  },
  updated() {
    // Re-init in case markup isn't ready.
    if (this.swiper) this.swiper.update();
  },
  mounted() {
    this.fetchData();

    window.addEventListener('resize', () => {
      this.onMobile = isMobile();
    });
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getSocialMediaPosts(this.lang);
        this.slides = data.timeline;
      } catch (error) {
        if (error.response) {
          console.error(error.response);
        }
      } finally {
        const navigationPrev = '.carousel__navigation .navigation-button--prev';
        const navigationNext = '.carousel__navigation .navigation-button--next';

        this.swiper = new Swiper(this.$refs.swiper, {
          breakpoints: {
            701: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1181: {
              slidesPerView: 3,
              spaceBetween: 44,
            },
            1441: {
              slidesPerView: 3,
              spaceBetween: 55,
            },
          },
          modules: [Navigation],
          navigation: {
            nextEl: navigationNext,
            prevEl: navigationPrev,
          },
          slidesPerView: 1.1,
          spaceBetween: 20,
          watchOverFlow: true,
        });

        // Show navigation if needed.
        this.$refs.navigation.classList.add('carousel__navigation--show');
      }
    },
    timeAgo(date) {
      // Post date should be in time from now form.
      return moment(date).locale(document.documentElement.lang).fromNow(true);
    },
  },
};
</script>
